import { createIcon } from '@chakra-ui/react';

const AIWritingIcon = createIcon({
  displayName: 'AIWritingIcon',
  path: (
    <g stroke="currentColor" strokeWidth="1.5" fill="none">
      <path d="M9 21L21 9L16.9999 5L5 17V21H9Z" />
      <path d="M4.57143 4.57143L5 3.5L5.42857 4.57143L6.5 5L5.42857 5.42857L5 6.5L4.57143 5.42857L3.5 5L4.57143 4.57143Z" />
      <path d="M14 8L18 12" />
    </g>
  ),
  viewBox: '0 0 24 24',
});

export default AIWritingIcon;
